import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useProvider } from '../../../hooks/useProvider';
import { Alert, AlertDescription, AlertTitle } from '../../shadcn/Alert';
import { Button } from '../../shadcn/Button';
import { CancelButton } from '../cancel-button';
import { UniLoginLayout } from './screen-layout';

/** The connection cannot go on from this page. Only a failed request creation can be retried here. */
export function UniLoginClosed({
  status,
  requestCreated,
  onRestart,
  onCancel,
}: {
  status: 'declined' | 'expired' | 'error';
  requestCreated: boolean;
  onRestart: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  const { provider_name } = useProvider();

  const title_key = status === 'error' ? (requestCreated ? 'connection_failed' : 'preparation_failed') : status;
  const description_key = status === 'error' ? (requestCreated ? 'connection_failed' : 'preparation_failed') : status;

  return (
    <UniLoginLayout
      actions={
        status === 'error' && !requestCreated ? (
          <Button variant="outline" type="button" onClick={onRestart}>
            {t('LoginScreen.unilogin.retry', { ns: 'translation', provider: provider_name })}
          </Button>
        ) : (
          <CancelButton onCancel={onCancel} />
        )
      }
    >
      <Alert variant="red">
        <CircleAlert />
        <AlertTitle>{t(`LoginScreen.unilogin.${title_key}.title`, { ns: 'translation', provider: provider_name })}</AlertTitle>
        <AlertDescription>
          {t(`LoginScreen.unilogin.${description_key}.description`, { ns: 'translation', provider: provider_name })}
        </AlertDescription>
      </Alert>
    </UniLoginLayout>
  );
}
